import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public shop requests may carry the customer session, but must never inherit
// the admin token. Admin and customer tokens can coexist in the same browser.
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("heritage-customer-token");
    if (token && !config._skipCustomerToken && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers["Authorization"] = `Bearer ${token}`;
    }
  } catch { /* localStorage can be unavailable in privacy mode */ }
  return config;
});

// If an old local token is stale but the shared httpOnly cookie is current,
// retry once without the Authorization header so the server can use the cookie.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    if (error?.response?.status === 401 && config && !config._customerCookieRetry) {
      config._customerCookieRetry = true;
      config._skipCustomerToken = true;
      if (config.headers) delete config.headers.Authorization;
      return api(config);
    }
    return Promise.reject(error);
  },
);

export default api;
